import { iconA11y, type IconProps } from './iconProps';

/**
 * Close / × mark — two square-ended bars (Figma Frame 21384555 / 884:106732).
 */
export function CloseIcon({ size = 24, title, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...iconA11y(title)}
    >
      {title ? <title>{title}</title> : null}
      <g transform="translate(12 12)">
        <rect
          x="-1"
          y="-7"
          width="2"
          height="14"
          fill="currentColor"
          transform="rotate(45)"
        />
        <rect
          x="-1"
          y="-7"
          width="2"
          height="14"
          fill="currentColor"
          transform="rotate(-45)"
        />
      </g>
    </svg>
  );
}
